import './common/icons'
import './common/axios'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import Toast from './plugins/Toast'
import pkjson from '../package.json'
import * as Sentry from '@sentry/vue'
import VueGtm from '@gtm-support/vue2-gtm'
import { store } from './store/store'
import { BrowserTracing } from '@sentry/tracing'

Sentry.init({
  release: 'v' + pkjson.version,
  environment: process.env.VUE_APP_ENV || 'development',
  dsn: 'https://c5b97895c1044870b68e74d8e308ee3b@o49094.ingest.sentry.io/5210196',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'https://app-refund.buildstaging.com/', 'https://refund.hotmart.com/', /^\//],
    }),
  ],
  trackComponents: true,
  tracesSampleRate: 1.0,
})

Vue.config.ignoredElements = [/^hot-/, 'font-awesome-icon', 'router-link']

// Plugins
Vue.use(VueGtm, {
  id: 'GTM-K5D7V5L',
  enabled: ['production', 'staging'].includes(process.env.VUE_APP_ENV)
})

Vue.use(Toast, store)

new Vue({
  store: store,
  router,
  i18n,
  hotToast: Toast,
  render: h => h(App),
}).$mount('#app')
